// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Grid, Image, Popup } from "semantic-ui-react";
import DashboardBarButton from "./DashboardBarButton";
import { jsx as _jsx } from "react/jsx-runtime";
export const DashboardBarButtonAjouter = props => {
  const {
    onClick
  } = props;
  const [open, setOpen] = React.useState(false);
  const handleClick = React.useCallback(type => () => {
    onClick?.({
      nom: "Tableau de bord",
      type
    });
    setOpen(false);
  }, [onClick]);
  const handleOpen = React.useCallback(() => {
    setOpen(true);
  }, []);
  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);
  const trigger = React.useMemo(() => /*#__PURE__*/_jsx(DashboardBarButton, {
    icon: "add",
    label: "Ajouter"
  }), []);
  const content = React.useMemo(() => /*#__PURE__*/_jsx(Grid, {
    className: "dashboard-bar-add",
    columns: 3,
    children: new Array(3).fill(0).map((r, ri) => /*#__PURE__*/_jsx(Grid.Row, {
      children: new Array(3).fill(0).map((c, ci) => /*#__PURE__*/_jsx(Grid.Column, {
        children: /*#__PURE__*/_jsx(Image, {
          as: "a",
          className: `struct${ri * 3 + (ci + 1)}`,
          size: "tiny",
          onClick: handleClick(ri * 3 + (ci + 1))
        })
      }, `col-${ci}`))
    }, `row-${ri}`))
  }), []);
  return /*#__PURE__*/_jsx(Popup, {
    position: "bottom left",
    trigger: trigger,
    content: content,
    onOpen: handleOpen,
    onClose: handleClose,
    open: open,
    on: "click",
    flowing: true,
    "data-sentry-element": "Popup",
    "data-sentry-component": "DashboardBarButtonAjouter",
    "data-sentry-source-file": "DashboardBarButtonAjouter.tsx"
  });
};
export default DashboardBarButtonAjouter;